import {
  type PredefinedPhrase,
  type PredefinedPhraseCategoryId,
  type PredefinedPhraseContentCategoryId,
} from 'types/chat';

export { SUPPORTER_ID } from '@avanta/shared/constants/chat';
export const PSYCHOLOGIST_ID = import.meta.env.VITE_PSYCHOLOGIST_ID;

export const EMOTIONAL_CHAT_AVAILABLE_START_TIME = import.meta.env
  .VITE_EMOTIONAL_CHAT_AVAILABLE_START_TIME;
export const EMOTIONAL_CHAT_AVAILABLE_END_TIME = import.meta.env
  .VITE_EMOTIONAL_CHAT_AVAILABLE_END_TIME;
export const EMOTIONAL_CHAT_UNAVAILABLE_DAYS =
  import.meta.env.VITE_EMOTIONAL_CHAT_UNAVAILABLE_DAYS?.split(',')
    .map((day: string) => Number(day.trim()))
    .filter((day: number) => day >= 1 && day <= 7) ?? [6, 7];

export const PREDEFINED_PHRASE_ALL_CATEGORY = 'all' satisfies PredefinedPhraseCategoryId;

type CatalogEntry = {
  categoryId: PredefinedPhraseContentCategoryId;
  count: number;
  idSlug?: string;
};

const PREDEFINED_PHRASE_CATALOG: CatalogEntry[] = [
  { categoryId: 'opening', count: 5 },
  { categoryId: 'validation', count: 7 },
  { categoryId: 'exploration', count: 7 },
  { categoryId: 'referral', count: 3 },
  { categoryId: 'closing', count: 3 },
  { categoryId: 'fixedNotice', count: 1, idSlug: 'fixed-notice' },
  { categoryId: 'farewell', count: 6 },
];

const MESSAGE_KEY_PREFIX = 'Chat.PredefinedPhrases.messages';
const CATEGORY_LABEL_KEY_PREFIX = 'Chat.PredefinedPhrases.categories';

const createPhrasesForCategory = (entry: CatalogEntry): PredefinedPhrase[] => {
  const { categoryId, count, idSlug = categoryId } = entry;

  return Array.from({ length: count }, (_, index) => {
    const messageNumber = index + 1;

    return {
      id: `${idSlug}-${messageNumber}`,
      categoryId,
      messageKey: `${MESSAGE_KEY_PREFIX}.${categoryId}.message${messageNumber}`,
    };
  });
};

export const PREDEFINED_PHRASE_CATEGORY_ORDER: PredefinedPhraseContentCategoryId[] =
  PREDEFINED_PHRASE_CATALOG.map(entry => entry.categoryId);

export const PREDEFINED_PHRASE_CATEGORY_FILTERS: PredefinedPhraseCategoryId[] = [
  PREDEFINED_PHRASE_ALL_CATEGORY,
  ...PREDEFINED_PHRASE_CATEGORY_ORDER,
];

export const PREDEFINED_PHRASE_CATEGORY_LABEL_KEYS = {
  all: `${CATEGORY_LABEL_KEY_PREFIX}.all`,
  opening: `${CATEGORY_LABEL_KEY_PREFIX}.opening`,
  validation: `${CATEGORY_LABEL_KEY_PREFIX}.validation`,
  exploration: `${CATEGORY_LABEL_KEY_PREFIX}.exploration`,
  referral: `${CATEGORY_LABEL_KEY_PREFIX}.referral`,
  closing: `${CATEGORY_LABEL_KEY_PREFIX}.closing`,
  fixedNotice: `${CATEGORY_LABEL_KEY_PREFIX}.fixedNotice`,
  farewell: `${CATEGORY_LABEL_KEY_PREFIX}.farewell`,
} satisfies Record<PredefinedPhraseCategoryId, string>;

export const PREDEFINED_PHRASES: PredefinedPhrase[] =
  PREDEFINED_PHRASE_CATALOG.flatMap(createPhrasesForCategory);

export const PREDEFINED_PHRASES_TOTAL_COUNT = PREDEFINED_PHRASES.length;
